import React, {Component} from 'react';
import {isEqual} from 'lodash';
import ChartComponent from './ChartComponent';
import {numberFormat} from '../utils/number';

const renderColorSquare = (color) => {
    let colorSquareStyle = {backgroundColor: color};

    return (
        <span
            className="color-square"
            style={colorSquareStyle}></span>
    );
}

export default class PieChartWithTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            showAll: false,
        };

        this.chartRef = React.createRef();

        this.rowOnMouseEnter = this.rowOnMouseEnter.bind(this);
        this.rowOnMouseLeave = this.rowOnMouseLeave.bind(this);
        this.handleShowAllClick = this.handleShowAllClick.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const previousData = prevProps.data;
        const newData = this.props.data;

        if (!isEqual(previousData, newData)) {
            this.setState({data: newData}, () => {
                if (this.chartRef && this.chartRef.current) {
                    this.chartRef.current.updateData(this.state.data);
                }
            });
        }
    }

    rowOnMouseEnter(idx) {
        let chart = this.chartRef.current;

        let meta = chart.chartInstance.getDatasetMeta(0);

        let point = meta.data[idx].getCenterPoint();

        let rect = chart.canvasRef.current.getBoundingClientRect();

        let evt = new MouseEvent("mousemove", {
            clientX: rect.left + point.x,
            clientY: rect.top + point.y,
        });

        let node = chart.canvasRef.current;

        node.dispatchEvent(evt);
    }

    rowOnMouseLeave(idx) {
        let chart = this.chartRef.current;

        let evt = new MouseEvent("mousemove", {
            clientX: 0,
            clientY: 0,
        });

        let node = chart.canvasRef.current;

        node.dispatchEvent(evt);
    }

    handleShowAllClick(e) {
        e.preventDefault();
        this.setState({showAll: !this.state.showAll});
    }

    render() {
        const {hasIntegerValues} = this.props;
        const {data, showAll} = this.state;

        if (!data.labels) {
            return null;
        }

        let labels = (showAll ? data.labels : data.labels.slice(0, 5));

        return (
            <div className="pie-chart-with-table">
                <div className="x_panel">
                    <div className="x_title">
                        <h2>
                            <i className="fa fa-angle-right"></i> {this.props.title}
                        </h2>
                        <div className="clearfix"></div>
                    </div>
                    <div className="x_content">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="chart-area" style={{position: "relative", height: "300px"}}>
                                    <ChartComponent ref={this.chartRef} hasIntegerValues={hasIntegerValues}/>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped table-hover">
                                        <tbody>
                                        {
                                            labels.map((label, idx) => {
                                                const num = idx + 1;
                                                const color = data.datasets[0].backgroundColor[idx];
                                                let count = data.datasets[0].data[idx];
                                                const colorSquare = renderColorSquare(color);

                                                if (!hasIntegerValues) {
                                                    count = numberFormat(count, 2, ',', '.');
                                                }

                                                return (
                                                    <tr key={idx}
                                                        onMouseEnter={() => this.rowOnMouseEnter(idx)}
                                                        onMouseLeave={() => this.rowOnMouseLeave(idx)}>
                                                        <td className="small-width"><strong>{num}</strong></td>
                                                        <td className="small-width">{colorSquare}</td>
                                                        <td>{label}</td>
                                                        <td className="medium-width numeric-value">
                                                            {count}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
